import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'

type Props = {
  dataCy?: string
  disabled?: boolean
  iconPath?: string
  label: string
  onClick: () => void
  size?: 'small' | 'medium'
}

const TextButton: FC<Props> = (props) => {
  const { dataCy, disabled, iconPath, label, onClick, size = 'medium' } = props

  const sizeStyle = (() => {
    switch (size) {
      case 'small':
        return text.font_small
      case 'medium':
        return text.font_medium
      default:
        return text.font_medium
    }
  })()

  const className = disabled ? `${styles.button__text_disabled} ${sizeStyle}` : `${styles.button__text} ${sizeStyle}`

  const dataCyStr = dataCy ? `text-button-${dataCy}` : 'text-button'

  return (
    <button className={className} data-cy={dataCyStr} disabled={disabled} onClick={onClick}>
      {iconPath && (
        <>
          <img src={iconPath} alt={label} />
          <Spacer size={4} axis={'horizontal'} />
        </>
      )}
      {label}
    </button>
  )
}

export default TextButton
